"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntroPage = void 0;
const index_1 = require("../../../../index");
const react_1 = __importDefault(require("react"));
const fullStory_1 = require("../../../../util/fullStory");
const Heading_1 = require("../../heading/Heading");
const Paragraph_1 = require("../../paragraph/Paragraph");
const Spacer_1 = require("../../spacer/Spacer");
const IntroPage = () => {
    const { propertyId } = react_1.default.useContext(index_1.AppContext);
    react_1.default.useEffect(() => {
        (0, fullStory_1.sendCustomFullStoryEvent)('smart_pricing_info_modal_viewed', {
            property_id: propertyId,
        });
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Heading_1.HeadingSmall, null, "Price like a professional"),
        react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
        react_1.default.createElement(Paragraph_1.Paragraph, null, "Smart Pricing does the heavy lifting \u2014 analyzing market trends and local demand to effortlessly boost your earnings. Your rates automatically adjust to stay perfectly tailored to real-time demand."),
        react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
        react_1.default.createElement(Paragraph_1.Paragraph, null, "Here's how it works:"),
        react_1.default.createElement("ul", null,
            ' ',
            react_1.default.createElement("li", null,
                react_1.default.createElement("strong", null, "Stay Ahead of the Curve:"),
                " Prices update every 48 hours, adapting to seasonal rushes and booking spikes\u2014so you\u2019re always in demand."),
            ' ',
            react_1.default.createElement("li", null,
                react_1.default.createElement("strong", null, "Smart Year-Round Planning:"),
                " Get a full-year pricing roadmap upfront, with continuous tweaks to match your booking patterns."),
            ' ',
            react_1.default.createElement("li", null,
                react_1.default.createElement("strong", null, "Unlock Higher Revenue:"),
                " Hosts earn up to 60% more by letting demand and occupancy drive their pricing."),
            ' '),
        react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
        react_1.default.createElement(Paragraph_1.Paragraph, null,
            "You\u2019re ",
            react_1.default.createElement("strong", null, "always in control"),
            ", but we\u2019ll help you maximize bookings and revenue.")));
};
exports.IntroPage = IntroPage;
//# sourceMappingURL=IntroPage.js.map